import styled from "styled-components";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
`;
export const DropZoneWrapper = styled.div`
  border: 2px dashed #474747;
  padding: 20px;
  > p {
    color: #474747;
  }
  `;
export const SignatureCanvasWrapper = styled.div`
  position: relative;
  width: 100%;
  canvas {
    width: 100%;
    height:160px;
  }
`;
export const ButtonClear = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: #355B94;
  color: #474747;
  padding: 6px;
  border-radius: 14px;
  font-size: 12px;
  cursor: pointer;
  text-transform: uppercase;
  color: #fff;
  border: none;
  font-family: "Archivo-Regular";
  width: fit-content;
  &:hover {
    background-color: #32568c;
  }
`;
